module.exports = __webpack_public_path__ + "1f80e7d43ab7ed4a5ff84844b97d44f5.svg";